// A react component that displays a menu of polygon options, with a preview of the polygon
//
// Props:
//  - polygons: the polygons to display
//  - onPolygonChange: a callback function that is called when the user selects a new polygon

import React, { useState } from "react";
import {
  Button,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { PolygonColours, PolygonTypes } from "../Designer/polygonTypes";
import { Swatch } from "./Swatch";

const PolygonTypeMenu = ({ type, onPolygonChange, size = "25px" }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleChange = (newPolygon) => {
    onClose();
    console.log("closing");
    onPolygonChange(newPolygon);
  };

  const onClose = () => {
    setAnchorEl(null);
  };
  const onOpen = (e) => {
    console.log("opening");
    setAnchorEl(e.currentTarget);
  };

  let options = Object.values(PolygonTypes);

  const menuItems = options.map((p, index) => (
    <MenuItem
      key={index}
      value={p}
      onClick={() => {
        handleChange(p);
      }}
      style={{
        background: type === p ? "lightgrey" : "white",
      }}
    >
      <Swatch
        selectedColor={PolygonColours[type]}
        background={PolygonColours[p]}
        onClick={() => {}}
        label={p}
      />
      {p && <Typography style={{ marginLeft: "1rem" }}>{p}</Typography>}
    </MenuItem>
  ));

  // const border = selected ? "solid 2px purple" : "solid 2px transparent";
  return (
    <Box
      style={{
        position: "relative",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: ".5rem",
      }}
    >
      <Swatch
        selectedColor={PolygonColours[type]}
        background={PolygonColours[type]}
        label={type}
        onClick={onOpen}
      />
      {/* <IconButton
                style={{
                    borderRadius: "50%",
                    width: "28px",
                    height: "28px",
                    border: "solid 2px transparent",
                    display: "flex",
                    alignSelf: "center",
                    justifyContent: "center",
                    padding: 0,
                }}
                onClick={onOpen}
            >
                <img
                    height={"100%"}
                    width={"100%"}
                    src={type.thumbnail}
                    alt={type.name}
                />
            </IconButton> */}
      <Menu
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={onClose}
      >
        {menuItems}
      </Menu>
    </Box>
  );
};

export default PolygonTypeMenu;
